
import { MapTo } from '@adobe/aem-react-editable-components';
import CustomerService, { CustomerServiceEditConfig } from './CustomerService';

export default MapTo('cob-corp-acquisition/components/creditonebank/customer-service')(CustomerService, CustomerServiceEditConfig);
        